import { Component } from '@angular/core';
import { HeaderComponent } from '../header/header.component';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from '../footer/footer.component';

@Component({
    selector: 'app-auth-layout',
    templateUrl: './auth-layout.component.html',
    styleUrls: ['./auth-layout.component.scss'],
    imports: [
        HeaderComponent,
        RouterOutlet,
        FooterComponent,
    ],
})
/** High level layout for pages accessed by unauthorised users (login, MFA etc) */
export class AuthLayoutComponent {}
